import React, { useEffect, useState } from 'react';
import { Col, Row, Spin } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { CollapseSvg } from '../../icons';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomGoBackButton,
  FormBlock,
  CustomText,
  GraySubtitle,
  PagesContainerUI,
  CustomTextContainer,
  CollapseButton,
  CollapsibleTextContainer,
  FormsContainer,
} from '../../styles/styled';
import { CloseCollapseTag } from '../NewApplicationPage/components/BookRegistrationComponent/styled';
import { BookApplicationFormType, LanguagesType } from '../NewApplicationPage/types';
import TextBook from './components/TextBook';
import { CollapsibleType } from './types';

export const ShowApplicationPage = () => {
  const [currentApplicationState, setCurrentApplicationState] = useState<BookApplicationFormType | null>(null);
  const [collapsesState, setCollapsesState] = useState<CollapsibleType>({});
  const [textBooksCollapseState, setTextbookCollapseState] = useState<CollapsibleType>({});
  const [languagesState, setLanguagesState] = useState<LanguagesType>([]);

  const idParam = useParams().id;

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<BookApplicationFormType>(endpoints.getApplicationById(idParam as string));
        const languagesResponse = await api.get<LanguagesType>(endpoints.getLanguages());

        setLanguagesState(languagesResponse.data);

        response.data.line_of_textbooks?.map((el, index) => {
          el.textbooks.map(
            (id) =>
              typeof id === 'number' &&
              setTextbookCollapseState((prevState) => {
                return { ...prevState, [id]: false };
              }),
          );

          setCollapsesState((prevState) => {
            return { ...prevState, [index]: false };
          });

          return true;
        });

        setCurrentApplicationState(response.data);
      } catch (err) {
        setTextbookCollapseState({});
      }
    })();
  }, [idParam]);

  return (
    <PagesContainerUI>
      <BlueLayout padding="20px 0 0 0 ">
        <Link to={routerPath.application}>
          <CustomGoBackButton>{'<'}</CustomGoBackButton>
        </Link>
        Заявление
      </BlueLayout>
      {currentApplicationState ? (
        <GraySubtitle>
          Зарегистрировано {currentApplicationState.date && currentApplicationState.date.split('-').reverse().join('.')}
          , № {currentApplicationState?.registration_number} {currentApplicationState.publisher?.email?.split(';')[0]}
        </GraySubtitle>
      ) : (
        <Spin />
      )}

      {currentApplicationState ? (
        <FormBlock white>
          <Row gutter={[10, 12]}>
            <Col span={24}>
              <CustomTextContainer>
                <CustomText color="#7594b9">ФИО заявителя</CustomText>
                <CustomText>{currentApplicationState.fio}</CustomText>
              </CustomTextContainer>
            </Col>
            <Col span={24}>
              <CustomTextContainer>
                <CustomText color="#7594b9">Наименование издателя учебника</CustomText>
                <CustomText>{currentApplicationState.publisher?.title}</CustomText>
              </CustomTextContainer>
            </Col>{' '}
            <Col span={24} />
            <Col span={24} />
            <Col span={12}>
              <CustomText color="#7594b9">Email</CustomText>
              <CustomText>{currentApplicationState.publisher?.email}</CustomText>
            </Col>
            <Col span={12}>
              <CustomText color="#7594b9">Телефон</CustomText>
              <CustomText>{currentApplicationState.publisher?.phone?.split(';').join(', ')}</CustomText>
            </Col>
            <Col span={24} />
            <Col span={24} />
            <Col span={24}>
              <CustomText color="#7594b9">Информация по учебнику</CustomText>
            </Col>
            <Col span={24} />
          </Row>
          <FormsContainer>
            {currentApplicationState.line_of_textbooks?.map((line_of_textbook, index) => {
              return (
                <FormBlock key={index}>
                  <CollapsibleTextContainer
                    onClick={() =>
                      setCollapsesState((prevState) => {
                        return {
                          ...prevState,
                          [index]: !collapsesState[index],
                        };
                      })
                    }
                  >
                    <span className="fat-text">Линейка {index + 1}</span>
                    <CloseCollapseTag>
                      <CollapseButton>{collapsesState[index] ? '—' : <CollapseSvg />}</CollapseButton>
                    </CloseCollapseTag>
                  </CollapsibleTextContainer>
                  {collapsesState[index] &&
                    line_of_textbook.textbooks.map((textbook) => {
                      return (
                        <TextBook
                          language={
                            textbook.language?.id
                              ? languagesState.filter(
                                  (el) => el.id === (textbook.language ? textbook.language.id : 1),
                                )[0].title
                              : 'отсутствует'
                          }
                          isCollapsed={textBooksCollapseState[textbook.id ? textbook.id : 0]}
                          setCollapsed={() =>
                            setTextbookCollapseState((prevState) => {
                              return {
                                ...prevState,
                                [textbook.id ? textbook.id : 1]: !textBooksCollapseState[textbook.id ? textbook.id : 1],
                              };
                            })
                          }
                          key={textbook.id}
                          book={textbook}
                        />
                      );
                    })}
                </FormBlock>
              );
            })}
          </FormsContainer>
        </FormBlock>
      ) : (
        <Spin />
      )}
    </PagesContainerUI>
  );
};
